import React, { ReactElement } from 'react';

import styled from '@emotion/styled';
import { device } from '../../../assets/styles/device';
import { isBrowserSupported } from './isBrowserSupported';

interface IProps {
  children: ReactElement;
}

const supported = isBrowserSupported();

const UnsupportedBrowser: React.FC<IProps> = (props: IProps) => {
  return supported ? (
    props.children
  ) : (
    <QuestionsWrapper>
      <h2>Sorry, we don't support your browser!</h2>
      <p>
        You are seeing this page because we detected an unsupported browser. Your browser is missing security features
        that our platform requires to operate.
      </p>
      <p>
        We suggest you choose one of the following options:
        <br />
        <Link href="https://www.google.com/intl/en/chrome/browser/">Click here</Link> to install or update Chrome
        (recommended)
        <br />
        <Link href="https://bestvpn.org/outdatedbrowser/en">Click here</Link> to install an alternative modern browser
      </p>
      <p>Once you have completed the above you should be able to log in successfully.</p>
      <p>
        If you still see this page after updating your browser or feel you are seeing this page in error, please{' '}
        <Link href="mailto:contact@cas-shield.com">contact us</Link> and be sure to include your browser name and
        version.
      </p>
    </QuestionsWrapper>
  );
};

const QuestionsWrapper = styled.div`
  padding: 40px 65px;

  @media ${device.mobile} {
    padding: 10px;
  }
`;

const Link = styled.a`
  color: #126dff;
  text-decoration: none;

  :hover {
    text-decoration: none;
  }
`;

export { UnsupportedBrowser };
